import React from "react";
import { array, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";

import "./oranism1.m.css";

const Organism1 = ({ stories, showSubHeading }) => {
  return (
    <div styleName={`base`}>
      <div styleName="first-story" className="first-story">
        {stories.length > 0 && (
          <NewsWithImage
            story={stories[0].story}
            aspectRatio={[3, 2]}
            imageType="image3x2"
            datatrackinglabelpos={12}
            showSubHeading={showSubHeading}
            showExcerpt={true}
          />
        )}
      </div>
      <div styleName="rest-stories" className="rest-stories">
        {stories.length > 1 &&
          stories
            .slice(1, 3)
            .map(({ story }, index) => (
              <NewsWithNoImage key={index} story={story} showExcerpt={true} showSubHeading={showSubHeading} />
            ))}
      </div>
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
  showSubHeading: bool,
};

export default Organism1;
